<template>
  <div>
    <FreeBottomSheet :name="name">
      <template #header="{ hide }">
        <FreeHeader class="p-4">
          <template #default>
            <h3 class="text-base font-medium">
              {{
                isMultimodal
                  ? t('routeDetailsBs.title')
                  : t('flightDetailsBs.title')
              }}
            </h3>
          </template>
          <template #rightAction>
            <FreeCloseButton @click="hide" />
          </template>
        </FreeHeader>
      </template>
      <template #default>
        <div class="cards-list-shadow px-4 pb-4">
          <slot name="top-content"></slot>
          <div class="space-y-4">
            <FlightDetailsCard
              v-for="(flight, idx) in flightsList"
              :key="idx"
              :source-page="sourcePage"
              :flight="flight"
              :flight-idx="idx"
              :dict="dict"
              :city-mismatches="cityMismatches"
              :display-luggage="displayLuggage"
              @onFaqItemClick="handleFaqItemClick"
              @onNewHandLuggageClick="$emit('onNewHandLuggageClick')"
            />
          </div>
          <slot name="bottom-content"></slot>
        </div>
      </template>
    </FreeBottomSheet>
    <FaqBottomSheet :name="faqBottomSheetName" />
  </div>
</template>

<script setup lang="ts">
  import { controllerModel, type ticketDetails } from 'shared';
  import { useI18n } from 'vue-i18n';
  import type { Dict } from '@aviata/platform-types';

  import { FlightDetailsCard } from '../../../entities/flight-details-card';
  import { FaqBottomSheet } from '../../../entities/faq-bottom-sheet';
  import {
    FreeBottomSheet,
    FreeCloseButton,
    FreeHeader,
  } from '../../../shared/ui';

  withDefaults(
    defineProps<{
      name: string;
      sourcePage?: string;
      flightsList: Array<ticketDetails.types.MappedFlight>;
      cityMismatches?: Array<ticketDetails.types.MismatchedCity> | null;
      dict?: Dict.Entity | null;
      displayLuggage?: boolean;
      isMultimodal?: boolean;
    }>(),
    {
      sourcePage: '',
      cityMismatches: null,
      dict: null,
      displayLuggage: true,
      isMultimodal: false,
    },
  );

  const { t } = useI18n();

  defineEmits<{
    (e: 'onNewHandLuggageClick'): void;
  }>();

  const bottomSheet = controllerModel.useBottomSheet();
  const faqBottomSheetName = 'faq-bottom-sheet';
  const handleFaqItemClick = (faqItemKey: string) => {
    bottomSheet.show(faqBottomSheetName, { faqItemKey });
  };
</script>

<style scoped>
  .cards-list-shadow {
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.05);
  }
</style>

<i18n src="../config/locales.json"></i18n>
